import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { adminGateway } from '@/services/adminGateway'
import type { UserIdentityDTO } from '@/services/adminTypes'

type Pending = { id: string; resolve: (person: UserIdentityDTO | null) => void; reject: (error: unknown) => void }
let pending: Pending[] = []
let scheduled = false
function lookup(id: string): Promise<UserIdentityDTO | null> {
  return new Promise((resolve, reject) => {
    pending.push({ id, resolve, reject })
    if (scheduled) return
    scheduled = true
    setTimeout(() => {
      const jobs = pending; pending = []; scheduled = false
      const ids = [...new Set(jobs.map(job => job.id))]
      for (let start = 0; start < ids.length; start += 100) {
        const chunk = ids.slice(start, start + 100)
        const consumers = jobs.filter(job => chunk.includes(job.id))
        Promise.resolve().then(() => adminGateway.getUserIdentities(chunk)).then(people => {
          const byID = new Map(people.map(person => [person.public_id, person]))
          consumers.forEach(job => job.resolve(byID.get(job.id) ?? null))
        }).catch(error => consumers.forEach(job => job.reject(error)))
      }
    }, 0)
  })
}

export function PersonIdentity({ id, name, avatar, number, showNumber = false, size = 36 }: { id?: string; name?: string; avatar?: string; number?: string; showNumber?: boolean; size?: number }) {
  const person = useQuery({ queryKey: ['admin-person', id], queryFn: () => lookup(id!), enabled: Boolean(id && !avatar), staleTime: 5 * 60_000, retry: false })
  const nickname = person.data?.nickname || (name && name !== id ? name : '用户')
  const userNumber = number || person.data?.user_number
  return <span className="person-identity">
    <Avatar size={size} src={avatar || person.data?.avatar_url} alt="" icon={<UserOutlined aria-hidden="true" />} />
    <span className="person-identity__text"><span>{nickname}</span>{showNumber && userNumber ? <small>用户编号：{userNumber}</small> : null}</span>
  </span>
}

export function UserNumber({ id, number }: { id: string; number?: string }) {
  const person = useQuery({ queryKey:['admin-person',id], queryFn:()=>lookup(id), enabled:Boolean(id && !number), staleTime:5*60_000, retry:false });
  return <span className="user-number">{number || person.data?.user_number || '—'}</span>;
}
